import React from 'react';
import { SCREEN_PADDING, TYPOGRAPHY } from '@/styles';
import { StyleSheet, Text, View } from 'react-native';

interface Props {
  text: string;
}

export const ListEmptyState: React.FC<Props> = ({ text }) => {
  return (
    <View style={styles.container}>
      <Text style={TYPOGRAPHY.p}>{text}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    padding: SCREEN_PADDING,
  },
});
